import BasicLayout from "layouts/BasicLayout";
import { DropshotPrivacyPolicy } from "pages/privacy-policy";
import React from "react";

const PrivacyPolicyRoute = () => {
	return (
		<BasicLayout>
			<DropshotPrivacyPolicy />
		</BasicLayout>
	);
};

export default PrivacyPolicyRoute;
